import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Tabs, Tab, Paper } from '@material-ui/core'

import { isValidString } from '../../../utils/string'
import { convertShopToOnFleetShop } from '../../../utils/common'
import { sortArrayByName } from '../../../utils/array'

import { getShopList, getShopFeatures } from '../../../actions/shop'
import {
  getHubsList,
  updateShopOnFleetKey,
  getEmployeeList,
  getOnFleetTeams,
  syncEmployeeOnFleet,
  updateEmployeeOnFleet,
  getWorkersByTeamOnFleet,
  createWorkerOnFleet,
  removeWorkerOnFleet,
} from '../../../actions/integration'
import { openErrorMessage } from '../../../actions/message'

import ContainerWithTitleWrapper from '../../HOC/ContainerWithTitle'
import OnFleetShopInfo from '../../../components/OnFleet/OnFleetShopInfo'
import OnFleetEmployeeInfo from '../../../components/OnFleet/OnFleetEmployeeInfo'
import OnFleetTeamInfo from '../../../components/OnFleet/OnFleetTeamInfo'
import OnFleetSettingInfo from '../../../components/OnFleet/OnFleetSettingInfo'
import ModalDialog from '../../../components/common/ModalDialog'
import { Appcues } from '../../../utils/constants'
import { getCompanyFeatures, getCompany } from '../../../actions/company'

const onFleetTabs = ['Settings', 'Shop', 'Team', 'Employee']

class OnFleet extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: 'Settings',
      onfleetTwoWays: {},
    }
  }

  componentDidMount() {
    this.props.dispatch(getShopList())
    this.props.dispatch(getEmployeeList())
    this.props.dispatch(getOnFleetTeams())
    this.props.dispatch(getCompany())
    this.props.dispatch(getShopFeatures())
    this.getCompanyFeatures2()
  }
  getCompanyFeatures2() {
    this.props.dispatch(getCompanyFeatures()).then((res) => {
      this.setState({
        onfleetTwoWays: res.onfleetTwoWays,
      })
    })
  }

  onFleetTabs = onFleetTabs.map((tab) => <Tab label={tab} value={tab} />)

  fetchHubList = (apiKey, validate) => {
    if (!isValidString(apiKey) && validate) {
      this.props.dispatch(openErrorMessage('Please enter a valid api key'))

      return
    }

    this.props.dispatch(getHubsList(apiKey))
  }

  onSave = (data, afterOnSave) => {
    const { hubList = {} } = this.props.integrationReducer
    const hubListValues =
      (hubList && hubList[data.onFleetApiKey] && hubList[data.onFleetApiKey].hubResults) || []
    const organizationResult =
      (hubList && hubList[data.onFleetApiKey] && hubList[data.onFleetApiKey].organizationResult) ||
      {}

    const selectedHub = hubListValues.find((hub) => hub.id === data.hubId)

    const onFleetShop = convertShopToOnFleetShop(
      { ...data, hubName: (selectedHub && selectedHub.name) || '' },
      hubListValues,
      organizationResult,
    )

    if (!onFleetShop.resetOnFleetInfo) {
      if (!isValidString(onFleetShop.apiKey)) {
        this.props.dispatch(openErrorMessage('Please enter a valid api key'))

        return
      }

      if (!isValidString(onFleetShop.hubId)) {
        this.props.dispatch(openErrorMessage('Please select hub'))

        return
      }
    }
    console.log(onFleetShop, 'onFleetShop')

    this.props.dispatch(updateShopOnFleetKey(onFleetShop)).then((response) => {
      Appcues.track('Onfleet shop updated')
      if (response.onFleetInfoUpdated) {
        this.props.dispatch(getShopList())
      }
      afterOnSave(response)
    })
  }

  onSaveResetOnfleetInfo = (data, afterOnSave) => {
    const { hubList = {} } = this.props.integrationReducer
    const hubListValues =
      (hubList && hubList[data.onFleetApiKey] && hubList[data.onFleetApiKey].hubResults) || []
    const organizationResult =
      (hubList && hubList[data.onFleetApiKey] && hubList[data.onFleetApiKey].organizationResult) ||
      {}

    const selectedHub = hubListValues.find((hub) => hub.id === data.hubId)

    let onFleetShop = {
      apiKey: data.onFleetApiKey,
      organizationId: organizationResult.id || '',
      organizationName: organizationResult.name || '',
      hubName: (selectedHub && selectedHub.name) || '',
      hubId: data.hubId || '',
      enableOnFleet: data.enableOnFleet,
      resetOnFleetInfo: data.resetOnFleetInfo,
      shopId: data.id,
    }

    this.props.dispatch(updateShopOnFleetKey(onFleetShop)).then((response) => {
      Appcues.track('Onfleet Shop Updated')
      this.props.dispatch(getShopList())
      afterOnSave(response)
    })
  }

  linkWorker = (employeeId, shopId, workerIds, teamId, afterOnSave) => {
    this.props
      .dispatch(syncEmployeeOnFleet({ id: employeeId, shopId, workerIds, teamId }))
      .then((response) => {
        if (response.onFleetWorkerId === null && response.synced === false) {
          this.props.dispatch(openErrorMessage(`We couldn't link the employee to the workers`))
        } else {
          this.props.dispatch(getEmployeeList())
        }
        afterOnSave()
      })
  }

  getWorkers = (teamId, shopId, callback) => {
    this.props.dispatch(getWorkersByTeamOnFleet(teamId, shopId)).then((res) => {
      callback(res)
    })
  }

  createNewWorker = (employeeId, shopId, teamId, afterOnSave) => {
    this.props.dispatch(createWorkerOnFleet({ id: employeeId, shopId, teamId })).then((res) => {
      Appcues.track('New Worker created')
      afterOnSave(res)
    })
  }

  removeWorker = (employeeId, shopId, teamId, afterOnSave) => {
    this.props
      .dispatch(removeWorkerOnFleet({ id: employeeId, shopId, teamId }))
      .then((response) => {
        Appcues.track('Worker removed from Onfleet Team')
        this.props.dispatch(getEmployeeList())
        this.props.dispatch(getOnFleetTeams())

        afterOnSave()
      })
  }

  handleChange = (event, tab) => {
    this.setState({
      activeTab: tab,
    })
  }

  convertTeamToOptions = (teamList) => {
    const options = []

    teamList.forEach((team) => {
      const { onFleetTeamInfoList } = team

      if (onFleetTeamInfoList) {
        onFleetTeamInfoList.forEach((teamInfo) => {
          options.push({
            value: `${team.shopId}BLAZE${teamInfo.teamId}`,
            label: `${team.shopName} | ${teamInfo.name}`,
          })
        })
      }
    })

    return options
  }

  renderTab = (activeTab) => {
    const { shopsList = {}, lastModified = null, shopFeaturesList = [] } = this.props.shopReducer

    const { hubList = {}, employeeList = {}, teamList = [] } = this.props.integrationReducer

    const { company = {}, companyFeatures = {} } = this.props.companyReducer

    const integrationLastModified = this.props.integrationReducer.lastModified

    let employeeListValues = employeeList.values || []

    employeeListValues = sortArrayByName(
      employeeListValues.map((employee) => ({
        ...employee,
        name: `${employee.firstName} ${employee.lastName}`,
      })),
    )

    let employeeListDriver = employeeListValues.filter((e) => e.driver)

    const teamListOptions = this.convertTeamToOptions(teamList)

    switch (activeTab) {
      case 'Shop':
        return (
          <OnFleetShopInfo
            shopsList={shopsList}
            fetchHubList={this.fetchHubList}
            hubList={hubList}
            onSave={this.onSave}
            lastModified={lastModified}
            onSaveResetOnfleetInfo={this.onSaveResetOnfleetInfo}
          />
        )
      case 'Employee':
        return (
          <OnFleetEmployeeInfo
            employeeList={employeeListDriver}
            teamList={teamListOptions}
            getWorkers={this.getWorkers}
            linkWorker={this.linkWorker}
            removeWorker={this.removeWorker}
            createNewWorker={this.createNewWorker}
            lastModified={integrationLastModified}
            shopsList={shopsList}
          />
        )
      case 'Team':
        return <OnFleetTeamInfo shopsList={shopsList} lastModified={integrationLastModified} />
      case 'Settings':
        return (
          <OnFleetSettingInfo
            shopsList={shopsList}
            shopFeaturesList={shopFeaturesList}
            lastModified={integrationLastModified}
            company={company}
            onfleetTwoWays={this.state.onfleetTwoWays}
            companyFeatures={companyFeatures}
          />
        )

      default:
        return null
    }
  }

  render() {
    const { activeTab } = this.state

    return (
      <div>
        <Paper>
          <Tabs
            value={activeTab}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            centered
          >
            {this.onFleetTabs}
          </Tabs>
        </Paper>
        {this.renderTab(activeTab)}
        <ModalDialog
          title={'Warning'}
          ref={(c) => (this.confirmModal = c)}
          onConfirm={this.createNewWorker}
          confirmText={'Yes'}
        >
          <p>This employee doesn't exist, Do you want to create new worker at onfleet?</p>
        </ModalDialog>
      </div>
    )
  }
}

const OnFleetWithTitle = ContainerWithTitleWrapper(OnFleet, 'Onfleet')
const OnFleetConnected = connect(
  ({ shopReducer, companyReducer, integrationReducer, dispatch }) => ({
    shopReducer,
    companyReducer,
    integrationReducer,
    dispatch,
  }),
)(OnFleetWithTitle)

export default OnFleetConnected



// WEBPACK FOOTER //
// ./src/containers/Settings/Integration/OnFleet.js